<div class="component-container-shroud" [class.open]="open()" woa-activatable (onActivate)="dismissPage()"
     [ngClass]="{
         'initialised': initialised(),
         'alignment-full': effectiveGeometry().alignment === PageAlignment.FULL
     }">
    <div class="component-container-wrapper"
         [ngClass]="{
             'initialised': initialised(),
             'alignment-top': effectiveGeometry().alignment === PageAlignment.TOP,
             'alignment-bottom': effectiveGeometry().alignment === PageAlignment.BOTTOM,
             'alignment-left': effectiveGeometry().alignment === PageAlignment.LEFT,
             'alignment-right': effectiveGeometry().alignment === PageAlignment.RIGHT,
             'alignment-full': effectiveGeometry().alignment === PageAlignment.FULL,
             'handle-enabled': responsiveService.isTouchDevice() && swipeDirection() !== Direction.NONE,
             'light-theme': themeModel.isLightTheme()
         }"
         [woa-css-var]="{
             '--specified-width': effectiveGeometry().width,
             '--specified-height': effectiveGeometry().height
         }"
         woa-responsive
         [pillarboxedOnMobile]="effectiveGeometry().pillarboxedOnMobile"
         [pillarboxedOnDesktop]="effectiveGeometry().pillarboxedOnDesktop"
         woa-swipable [swipeDirection]="swipeDirection()" [swipeRestoreDelay]="300"
         [swipeScroller]="pageSpec.componentRef.instance.pageLayout()?.pageScrollerER()"
         (onSwipe)="dismissPage()"
         woa-activatable>
        <ng-container #content></ng-container>
    </div>
</div>
